
export const TwoFactorType = {
    SMS: 1,
    GOOGLE_AUTHENTICATOR: 2,
}